import { schemaUpdates } from "plugins/schema-updates/controller/schema-updates"
import { emptyArray } from "lib/empty-array"
import { Grid2, Typography } from "@mui/material"
import { PagedRepeat } from "lib/@components/paged-repeat"
import { DATE_FORMATS } from "lib/@constants/date-format"
import { SuccessIcon, WarningIcon } from "theme/overrides/CustomIcons"

function formatDisplayValue(value) {
    if (value == null) return ""
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
        return String(value)
    }

    try {
        return JSON.stringify(value)
    } catch {
        return String(value)
    }
}

export function SchemaUpdates() {
    const rows = schemaUpdates.useResults() ?? emptyArray

    const sortedRows = rows.sort((a, b) => {
        // First compare by _modified
        if (b._modified !== a._modified) {
            return new Date(b._modified) - new Date(a._modified)
        }
        // If _modified are equal, compare by _created
        return new Date(b._created) - new Date(a._created)
    })
    return (
        <>
            <Grid2 container sx={{ border: "1px solid #ddd", width: "100%", bgcolor: "#fff", alignItems: "center" }}>
                <Grid2
                    size={0.5}
                    sx={{ padding: "4px", display: "flex", alignItems: "center", justifyContent: "center" }}
                ></Grid2>
                <Grid2 size={4} sx={{ padding: "4px" }}>
                    <Typography variant={"subtitle1"}>Update File</Typography>
                </Grid2>

                <Grid2 size={2} sx={{ padding: "4px" }}>
                    <Typography variant={"subtitle1"}>Modified</Typography>
                </Grid2>
                <Grid2 size={5.5} sx={{ padding: "4px" }}>
                    <Typography variant={"subtitle1"}>Result</Typography>
                </Grid2>
            </Grid2>
            <PagedRepeat list={sortedRows} item={<SchemaUpdate />} />
        </>
    )
}

export function SchemaUpdate({ item }) {
    const { _id, result, _modified, error } = item
    const [file] = _id.split(":")
    const modified = new Date(_modified).format(DATE_FORMATS.long)
    const formattedError = formatDisplayValue(error)
    const formattedResult = formatDisplayValue(result)

    return (
        <Grid2 container sx={{ border: "1px solid #ddd", width: "100%", bgcolor: "#fff", alignItems: "center" }}>
            <Grid2 size={0.3} sx={{ padding: "4px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                {!error && <SuccessIcon style={{ color: "green" }} />}
                {error && <WarningIcon style={{ color: "red" }} />}
            </Grid2>
            <Grid2 size={4} sx={{ padding: "4px" }}>
                {file}
            </Grid2>

            <Grid2 size={2} sx={{ padding: "4px" }}>
                {modified}
            </Grid2>

            <Grid2 size={5.5} sx={{ padding: "4px" }}>
                {formattedError} {formattedResult}
            </Grid2>
        </Grid2>
    )
}
